/**
 * Stream A — A22: Ease Score (real API)
 * No mocks. Direct apiFetch.
 */
import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "@/lib/api-client";
import { useActiveTenantModule } from "@/hooks/use-active-tenant-module";

export interface EaseScoreData {
  score: number;
  trend: "up" | "down" | "flat";
  change: number;
}

export function useEaseScore() {
  const [data, setData] = useState<EaseScoreData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const crmModule = useActiveTenantModule("crm");

  const fetchScore = useCallback(async () => {
    if (crmModule.isLoading) {
      return;
    }

    if (!crmModule.isEnabled) {
      setData(null);
      setIsLoading(false);
      return;
    }

    try {
      const res = await apiFetch<{ data: EaseScoreData }>("/crm/intelligence/ease-score");
      setData(res.data);
    } catch {
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, [crmModule.isEnabled, crmModule.isLoading]);

  useEffect(() => { fetchScore(); }, [fetchScore]);

  return { data, isLoading };
}
